import { render, staticRenderFns } from "./StatusApproval.vue?vue&type=template&id=b6076b2a"
import script from "./StatusApproval.vue?vue&type=script&lang=js"
export * from "./StatusApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports